import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

const PricingContext = createContext(null);
const API = process.env.REACT_APP_BACKEND_URL;

const DEFAULT = {
  packages: [],
  local_launch: { name: 'Local Launch Website', price: '399', description: '', features: [] },
  bolt_ons: [],
  care_plans: { feature_labels: [], plans: [] },
  project_builder: {
    tiers: [],
    bolt_ons: [],
    care_plans: [],
    hosting_tiers: [],
    no_hosting_warnings: [],
    brief_helper_chips: [],
  },
};

export function PricingProvider({ children }) {
  const [data, setData] = useState(DEFAULT);
  const location = useLocation();

  const refresh = useCallback(() => {
    fetch(`${API}/api/pricing`)
      .then(r => r.json())
      .then(d => { if (d && d.packages) setData({ ...DEFAULT, ...d, project_builder: { ...DEFAULT.project_builder, ...(d.project_builder || {}) } }); })
      .catch(() => {});
  }, []);

  // Initial load + re-fetch when entering /pricing or leaving /admin so admin
  // edits propagate to the public quote-builder cards without a full reload.
  useEffect(() => {
    refresh();
  }, [refresh, location.pathname]);

  return (
    <PricingContext.Provider value={data}>
      {children}
    </PricingContext.Provider>
  );
}

export function usePricing() {
  return useContext(PricingContext) || DEFAULT;
}
